// extracted by mini-css-extract-plugin
export var group = "HotelSearchBoxTypeahead-module--group--ea685";
export var highlighted = "HotelSearchBoxTypeahead-module--highlighted--8ea1d";
export var icon = "HotelSearchBoxTypeahead-module--icon--adca2";
export var input = "HotelSearchBoxTypeahead-module--input--08301";
export var inputAndButtonWrapper = "HotelSearchBoxTypeahead-module--inputAndButtonWrapper--2dc84";
export var item = "HotelSearchBoxTypeahead-module--item--6fe64";
export var list = "HotelSearchBoxTypeahead-module--list--7d1b7";
export var listbox = "HotelSearchBoxTypeahead-module--listbox--269cb";
export var loader = "HotelSearchBoxTypeahead-module--loader--71f53";
export var noResults = "HotelSearchBoxTypeahead-module--noResults--8a3ed";
export var open = "HotelSearchBoxTypeahead-module--open--aaff8";
export var selected = "HotelSearchBoxTypeahead-module--selected--4014e";
export var srOnly = "HotelSearchBoxTypeahead-module--srOnly--f8ae0";
export var typeahead = "HotelSearchBoxTypeahead-module--typeahead--ac64b";